module.exports = __webpack_public_path__ + "static/img/down_porfile_bg.2302f8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down_porfile_bg.png
// module id = GRSk
// module chunks = 1